<template>
    <div>
        <h3 class="is-size-3">Paises</h3>
        <p>
            <code>GET {{ host }}/api/countries</code>
        </p>
        <h5 class="is-size-6">Respuesta (Ejemplo):</h5>
        <pre>
            <code>[
                {
                    "countryCode":"MXN",
                    "countryName":"México"
                },
                {
                    "countryCode":"USA",
                    "countryName":"Estados Unidos (los)"
                }
                ...
            ]</code>
        </pre>
        <hr />
        <h3 class="is-size-3">Datos de un país</h3>
        <p>
            <code>GET {{ host }}/api/countryData/{countryCode}</code>
        </p>
        <h5 class="is-size-6">Respuesta (Ejemplo):</h5>
        <pre>
            <code>{
                "countryCode":"MXN",
                "countryName":"México"
            }</code>
        </pre>
        <hr />
        <h3 class="is-size-3">Estados por país</h3>
        <p>
            <code>GET {{ host }}/api/states/{countryCode?}</code>
        </p>
        <h5 class="is-size-6">Respuesta (Ejemplo):</h5>
        <pre>
            <code>[
                {
                    "stateCode":"08",
                    "stateName":"CHIHUAHUA",
                    "stateAbbr":"CH"
                },
                {
                    "stateCode":"09",
                    "stateName":
                    "CIUDAD DE MEXICO",
                    "stateAbbr":"DF"
                }
                ...
            ]</code>
        </pre>
        <hr />
        <h3 class="is-size-3">Datos de un estado</h3>
        <p>
            <code>GET {{ host }}/api/stateData/{stateCode?}</code>
        </p>
        <h5 class="is-size-6">Respuesta (Ejemplo):</h5>
        <pre>
            <code>{
                "stateCode": "08",
                "stateName": "CHIHUAHUA",
                "stateAbbr": "CH",
                "riskProbability": "2",
                "riskImpact": "2",
                "isoCode": "MX-CHH"
            }</code>
        </pre>
        <hr />
        <h3 class="is-size-3">Ciudades de un estado</h3>
        <p>
            <code>GET {{ host }}/api/locations/{stateCode?}</code>
        </p>
        <h5 class="is-size-6">Respuesta (Ejemplo):</h5>
        <pre>
            <code>[
                {
                    "locationCode": "00901006",
                    "locationName": "AHUMADA",
                    "stateCode": "08",
                    "postalCodes": [32820,32830,32815,32800,32800,32814,32800,32800,32813,32811,32812,32845,32818,32816,32840,32830,32847,32847,32800]
                },
                {
                    "locationCode": "00902006",
                    "locationName": "ALDAMA",
                    "stateCode": "08",
                    "postalCodes": []
                },
                {
                    "locationCode": "00903009",
                    "locationName": "ALLENDE",
                    "stateCode": "08",
                    "postalCodes": []
                }
                ...
            ]</code>
        </pre>
        <hr />
        <h3 class="is-size-3">Datos de una ciudad</h3>
        <p>
            <code>GET {{ host }}/api/locationData/{locationCode?}</code>
        </p>
        <h5 class="is-size-6">Respuesta (Ejemplo):</h5>
        <pre>
            <code>{
                "locationCode": "00901006",
                "locationName": "AHUMADA",
                "stateCode": "08",
                "postalCodes": [32820,32830,32815,32800,32800,32814,32800,32800,32813,32811,32812,32845,32818,32816,32840,32830,32847,32847,32800]
            }</code>
        </pre>
        <hr />
        <h3 class="is-size-3">Colonias por código postal</h3>
        <p>
            <code>GET {{ host }}/api/colonies/{postalCode?}</code>
        </p>
        <h5 class="is-size-6">Respuesta (Ejemplo):</h5>
        <pre>
            <code>[
                {
                    "colonyId": 13860,
                    "colony": "Insurgentes I",
                    "colonyType": "Colonia",
                    "cp": 31125,
                    "locationCode": "00919003",
                    "stateCode": "08",
                    "city": "Chihuahua",
                    "countryCode": "MEX"
                },
                {
                    "colonyId": 13861,
                    "colony": "Bosques de San Pedro",
                    "colonyType": "Fraccionamiento",
                    "cp": 31125,
                    "locationCode": "00919003",
                    "stateCode": "08",
                    "city": "Chihuahua",
                    "countryCode": "MEX"
                },
                {
                    "colonyId": 13862,
                    "colony": "Cafetales",
                    "colonyType": "Fraccionamiento",
                    "cp": 31125,
                    "locationCode": "00919003",
                    "stateCode": "08",
                    "city": "Chihuahua",
                    "countryCode": "MEX"
                },
                {
                    "colonyId": 13863,
                    "colony": "Las Delicias",
                    "colonyType": "Fraccionamiento",
                    "cp": 31125,
                    "locationCode": "00919003",
                    "stateCode": "08",
                    "city": "Chihuahua",
                    "countryCode": "MEX"
                },
                ...
            ]</code>
        </pre>
        <hr />
        <h3 class="is-size-3">Colonias por códigos postales</h3>
        <p> <code>POST {{ host }}/api/coloniesByPostalCodes</code> </p>
        <br>
        <h5 class="is-size-6">El endpoint recibe un parametro en el Body:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>postalCodes</strong>
                    <ul>
                        <li>Obligatorio</li>
                        <li>Formato como array (Ej. [32820,32830,32815,32800,32800,32814,32800,32800,32813,32811,32812,32845,32818,32816,32840,32830,32847,32847,32800])</li>
                    </ul>
                </li>
            </ul>
        </div>
        <br/>
        <h5 class="is-size-6">Respuesta:</h5> 
        <pre>
        <code>[
            {
                "colonyId": 16556,
                "colony": "Lucero",
                "colonyType": "Estación",
                "cp": 32820,
                "stateCode": "08"
            },
            {
                "colonyId": 16558,
                "colony": "Valle de la Esperanza",
                "colonyType": "Colonia",
                "cp": 32830,
                "stateCode": "08"
            },
            {
                "colonyId": 16553,
                "colony": "Ojo Caliente",
                "colonyType": "Colonia",
                "cp": 32815,
                "stateCode": "08"
            }
            ...
        ]</code>
        </pre>
        <hr />
        <h3 class="is-size-3">Datos de la colonia</h3>
        <p>
            <code>GET {{ host }}/api/colony/{colonyId?}</code>
        </p>
        <h5 class="is-size-6">Respuesta (Ejemplo):</h5>
        <pre>
            <code>{
                "colonyId": 13860,
                "colony": "Insurgentes I",
                "colonyType": "Colonia",
                "cp": 31125,
                "stateCode": "08"
            }</code>
        </pre>
    </div>
</template>

<script>
export default {
    name: 'Regions',
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style scoped>
p {
    margin-bottom: 15px;
}
</style>
